<div class="session-card">
    <a *ngIf="session.id"
       uiSref="session-detail"
       [uiParams]="{ id: session.id }"
       class="calendar-card-content" [ngClass]="colorStyle()">
        <span class="training-title" [title]="session.trainingTitle">
            {{session.trainingTitle}}
            <span *ngIf="session.linkedTrainingTitle">({{session.linkedTrainingTitle}})</span>
            <span *ngIf="!session.linkedTrainingTitle && session.subject">({{session.subject}})</span>
        </span>
        <span class="trainer-name" *ngIf="hasTrainer()">{{session.trainerFullName}}</span>
        <span class="room-name" *ngIf="session.roomName">{{session.roomName}} <span *ngIf="session.roomCapacity">({{session.roomCapacity}})</span></span>
        <span class="warning" *ngIf="!hasTrainer() || !hasLocation()">
            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
            <span *ngIf="!hasTrainer()">{{'session-calendar.no-trainer' | translate}}</span>
            <span *ngIf="!hasTrainer() && !hasLocation()"> & </span>
            <span *ngIf="!hasLocation()">{{'session-calendar.no-location' | translate}}</span>
        </span>
        <div class="full-line-label">
            <div class="label label-default company-label">
                {{session.intra ? "Intra" : "Inter"}}
            </div>
            <div class="label label-default company-label" *ngIf="session.intra && session.customerName" [title]="session.customerName">
                {{session.customerName}}
            </div>
            <div class="trainees-count">
                <div><b>{{confirmed}}</b> confirmés</div>
                <div><b>{{options}}</b> options</div>
            </div>
        </div>
    </a>
</div>



// WEBPACK FOOTER //
// ./src/app/_screens/session/calendar/card/card.component.html